module.exports = __webpack_public_path__ + "static/media/sound_3.491577d4.mp3";